import React from "react";
import "../../styles/ServicePages.css";

const LogisticsPage = () => {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <div className="service-hero">
        <h1>🚚 Logistics & Distribution Solutions</h1>
        <p>End-to-end logistics solutions combining multimodal transport with technology-driven tracking and optimization</p>
      </div>

      {/* Main Content */}
      <div className="service-content">
        {/* Overview */}
        <section className="overview-section">
          <h2>Integrated Logistics Expertise</h2>
          <p className="overview-text">
            AROCL provides comprehensive logistics and distribution services covering land, sea, air, and rail transport. 
            Our technology platform enables real-time tracking, route optimization, and supply chain visibility.
          </p>
        </section>

        {/* Features Grid */}
        <section className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">🚗</span>
            <h3>Road Transport</h3>
            <p>Nationwide road logistics with fleet management and tracking systems</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🚆</span>
            <h3>Rail Logistics</h3>
            <p>Economical rail transport for bulk commodities and containerized freight</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🌐</span>
            <h3>Multimodal Solutions</h3>
            <p>Seamless integration of multiple transport modes for optimal efficiency</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📍</span>
            <h3>Last-Mile Delivery</h3>
            <p>Reliable final-mile delivery to customers nationwide</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📡</span>
            <h3>Real-Time Tracking</h3>
            <p>GPS tracking and live updates for complete shipment visibility</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">⚙️</span>
            <h3>Route Optimization</h3>
            <p>AI-powered route planning for efficiency and cost savings</p>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <h2>Logistics Benefits</h2>
          <div className="benefits-list">
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Cost Efficiency</h4>
                <p>Optimize routes and reduce operational costs significantly</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Complete Visibility</h4>
                <p>Track shipments in real-time from origin to destination</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Scalable Solutions</h4>
                <p>Handle growing volumes with flexible logistics infrastructure</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Reliability</h4>
                <p>99.8% on-time delivery with professional operations team</p>
              </div>
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="process-section">
          <h2>Logistics Journey</h2>
          <div className="process-timeline">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Planning & Assessment</h3>
              <p>Analyze your logistics needs and design optimal transport solutions</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Pickup & Consolidation</h3>
              <p>Collect goods and consolidate for efficient transport</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Transport & Tracking</h3>
              <p>Execute shipment with continuous monitoring and updates</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Final Delivery</h3>
              <p>Last-mile delivery with customer notification and proof</p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="stats-section">
          <div className="stat-card">
            <div className="stat-number">500+</div>
            <div className="stat-label">Fleet Vehicles</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">99.8%</div>
            <div className="stat-label">On-Time Delivery</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">50</div>
            <div className="stat-label">States Covered</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">10K+</div>
            <div className="stat-label">Deliveries/Month</div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <h2>Streamline Your Supply Chain</h2>
          <p>Partner with AROCL for comprehensive logistics solutions tailored to your business needs.</p>
          <div className="cta-buttons">
            <button className="cta-btn cta-btn-primary" onClick={() => window.location.href = "tel:+919876543210"}>📞 Call Now</button>
            <button className="cta-btn cta-btn-secondary" onClick={() => window.location.href = "https://wa.me/919876543210?text=I need logistics solutions for my business."}>💬 Chat on WhatsApp</button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default LogisticsPage; 

